<template>
  <main
    id="top"
    class="tv-home"
  >
    <Hero :data="data" />
    <Campus :data="data" />
    <Buildings :data="data" />
    <Services :data="data" />
    <Access :data="data" />
  </main>
</template>

<script>
import Hero from '@/views/home/01_Hero.vue'
import Campus from '@/views/home/02_Campus.vue'
import Buildings from '@/views/home/03_Buildings.vue'
import Services from '@/views/home/04_Services.vue'
import Access from '@/views/home/05_Access.vue'

export default {
  name: 'HomeView',
  components: {
    Hero,
    Campus,
    Buildings,
    Services,
    Access
  },
  props: {
    data: {
      type: Object,
      required: true
    }
  }
}
</script>

<style lang="scss">
.tv-home {
  background: $navy;
}
</style>
